/**
 * 表格，分页Mixins
 */
export default {
	data() {
		return {
			loading: false,
			tableData: [], // 列表数据
			pageIndex: 1, // 当前页
			pageSize: 30, // 每页数量
			totalCount: 0, // 总记录数
			pageSizes: [30, 90, 150, 300],
		};
	},
	mounted() {
		
	},
	methods: {
		// 选择每页几条数据
		async handleSizeChange(e) {
      try {
        this.pageSize = e;
        this.pageIndex = 1;
        await this.getTableList(); // 记得在调用的组件中写这个方法，不然会报错
      } catch(err) {
        console.error(err)
      }
		},
		// 选择第几页
		async handleCurrentChange(e) {
      try {
        this.pageIndex = e;
        await this.getTableList();
      } catch(err) {
        console.error(err)
      }
		},
	},
};
